// extracted by mini-css-extract-plugin
module.exports = {"reading-time":"ReadingTime_reading-time__1wjh1","reading-time__icon":"ReadingTime_reading-time__icon__3Bf9S","reading-time__time":"ReadingTime_reading-time__time__166JZ"};